/**
 * <pg-marquee>: the pause button for the partner-logo marquee (sections/pg-logo-marquee.liquid).
 * Hover and focus already pause it in CSS; this covers touch and keyboard users (WCAG 2.2.2).
 * Under reduced motion the marquee is a static row, so the button stays hidden.
 */
import { PgElement, define, reducedMotion } from '@pg/core';

class PgMarquee extends PgElement {
  mount() {
    const { toggle, label } = this.refs;
    if (!toggle || reducedMotion()) return;
    toggle.disabled = false;
    toggle.addEventListener(
      'click',
      () => {
        const paused = toggle.getAttribute('aria-pressed') !== 'true';
        toggle.setAttribute('aria-pressed', String(paused));
        this.classList.toggle('is-paused', paused);
        if (label) label.textContent = (paused ? this.dataset.labelPlay : this.dataset.labelPause) || '';
      },
      { signal: this.signal },
    );
  }
}

define('pg-marquee', PgMarquee);
